var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12.75 9V10.6893L13.5303 11.4697C13.8232 11.7626 13.8232 12.2374 13.5303 12.5303C13.2374 12.8232 12.7626 12.8232 12.4697 12.5303L11.4697 11.5303C11.329 11.3897 11.25 11.1989 11.25 11V9C11.25 8.58579 11.5858 8.25 12 8.25C12.4142 8.25 12.75 8.58579 12.75 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C3.34315 3 2 4.34315 2 6V16C2 17.6569 3.34315 19 5 19H9L11.2929 21.6602C11.6834 22.1133 12.3166 22.1133 12.7071 21.6602L15 19H19C20.6569 19 22 17.6569 22 16V6C22 4.34315 20.6569 3 19 3H5ZM17.5 11C17.5 14.0376 15.0376 16.5 12 16.5C8.96243 16.5 6.5 14.0376 6.5 11C6.5 7.96243 8.96243 5.5 12 5.5C15.0376 5.5 17.5 7.96243 17.5 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerChat);
export default __webpack_public_path__ + "static/media/timer-chat.2313c89ee86b79bc937ee6162cbb38fc.svg";
export { ForwardRef as ReactComponent };